import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

// Holds the current Intercom unread message count so it can be surfaced as a
// badge on the chat nav item. The count originates from the IntercomProvider's
// `onUnreadCountChange` callback (app root) and is read by the sidebar (deep in
// the tree), so it is lifted into context.
export const IntercomUnreadContext = createContext<
  [number, Dispatch<SetStateAction<number>>]
>([0, () => {}]);

export const IntercomUnreadProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const unreadState = useState(0);

  return (
    <IntercomUnreadContext.Provider value={unreadState}>
      {children}
    </IntercomUnreadContext.Provider>
  );
};

// Read-only accessor for consumers that just need the count.
export function useIntercomUnread(): number {
  const [unreadCount] = useContext(IntercomUnreadContext);
  return unreadCount;
}

// Accessor for the wiring point that needs to update the count.
export function useSetIntercomUnread(): Dispatch<SetStateAction<number>> {
  const [, setUnreadCount] = useContext(IntercomUnreadContext);
  return setUnreadCount;
}
